import http from '@/utils/http';

//获取腾讯短信验证appid
export const getCaptchaAppId = () => {
  return http({
    url: '/app/cas/captcha',
    method: 'get'
  });
};
